import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCN2Lgp7OBQM8kxuSMlpMvf4mvWJoZL_Jw",
  authDomain: "biancode-f976d.firebaseapp.com",
  projectId: "biancode-f976d",
  storageBucket: "biancode-f976d.firebasestorage.app",
  messagingSenderId: "764409784098",
  appId: "1:764409784098:web:46da2ad6b33cc40cf9277b",
  measurementId: "G-SS60SLPMCE"
};

let db;

try {
  const app = initializeApp(firebaseConfig);
  db = getFirestore(app);
} catch (error) {
  console.error("[Firebase] Initialization failed:", error);
}

export { db };
